import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
// import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
// import Delete from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Edit from "@material-ui/icons/Edit";
import School from "@material-ui/icons/School";
import * as React from "react";
import { Link } from "react-router-dom";
import Component from "../../components/Component";
import Modal from "../../components/Modal";
import Page from "../../components/Page";
import withAxios, { IAxiosProps } from "../../components/withAxios";
import { ISchool } from "src/services";
import { ISchoolAdminPageProps } from "./IAdminPageProps";
import SearchSchoolView from "src/components/searchSchool";
import { Box, CircularProgress, Typography} from "@material-ui/core";
import {

  FormControlLabel,
 
} from "@material-ui/core";

const styles = () => ({
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ISchoolAdminPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ISchoolsPageState {
  deleteSchool?: ISchool;
  modalVisible: boolean;
  deleteSchoolSlug: string;
  screenSchool: any;
  loading: boolean;
  loadMore: boolean;
  totalPage: number;
  page: number;
  searchBy: string;
  searchValue: any;
  listDeleteSchool: any;
  searchTerm:any;
}

export default withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISchoolsPageState> {
      public readonly state = this.buildState({
        deleteSchoolSlug: "",
        modalVisible: false,
        screenSchool: [],
        loading: false,
        loadMore: false,
        totalPage: 1,
        page: 1,
        searchBy: "",
        searchValue: "",
        listDeleteSchool: [],
        searchTerm:"all"
      });

      private deleteSchoolSlugChange = this.stateInputEventHandler((v) => ({
        deleteSchoolSlug: v,
      }));

      public componentDidMount() {
        this.loadUserGetSchool()
        // this.props.loadSchools();
      }
      public calculateTotalPages(totalData: any, itemsPerPage: any) {
        return Math.ceil(totalData / itemsPerPage);
      }

      public handleInputChange = (e: any) => {
        const newValue = e.target.value;
        this.setState({searchTerm:newValue });
        this.setState({
          page: 1,
          totalPage: 1,
          searchBy: "status",
          searchValue: newValue,
          screenSchool: []
        }, () => {
          this.loadUserGetSchool2()
        })
      };
    
      public loadUserGetSchool = (initial = false) =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: initial ? true : false,
            loadMore: !initial ? true : false,
          },
          {
            loadMore: false,
            loading: false,
          },
          async () => {
            let url = ''
            
            if (this.state.searchBy !== "" && this.state.searchValue !== "") {
              url = `school/getAll?pageNumber=${this.state.page}&pageSize=10&${this.state.searchBy}=${this.state.searchValue}`
            } else {
              url = `school/getAll?pageNumber=${this.state.page}&pageSize=10`
            }
            const res: any = await this.buildGet<ISchool[]>(this, url)()
            console.log("res===========>School", res.data)
            if (res?.data?.totalCount > 0) {
              const totalPages = this.calculateTotalPages(res?.data?.totalCount, 10);
              this.setState({
                screenSchool: [...this.state.screenSchool, ...res?.data?.data],
                totalPage: totalPages,
                loadMore: false,
              });
            } else {
              this.setState({
                screenSchool: [],
                totalPage: 1,
                page: 1,
                loadMore: false,
              })
            }

          },
          () => {
            // Do nothing
          }
        );

        public loadUserGetSchool2 = (initial = false) =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loading: initial ? true : false,
              loadMore: !initial ? true : false,
            },
            {
              loadMore: false,
              loading: false,
            },
            async () => {
              let url = ''            
              if (this.state.searchBy !== "" && this.state.searchValue !== "") {
                url = `school/getAll?pageNumber=${this.state.page}&pageSize=10&${this.state.searchBy}=${this.state.searchValue}`
              } else {
                url = `school/getAll?pageNumber=${this.state.page}&pageSize=10`
              }
              const res: any = await this.buildGet<ISchool[]>(this, url)()
              console.log("res===========>School", res.data)
              if (res?.data?.totalCount > 0) {
                const totalPages = this.calculateTotalPages(res?.data?.totalCount, 10);
                this.setState({
                  screenSchool: [...this.state.screenSchool, ...res?.data?.data],
                  totalPage: totalPages,
                  loadMore: false,
                });
              } else {
                this.setState({
                  screenSchool: [],
                  totalPage: 1,
                  page: 1,
                  loadMore: false,
                })
              }
  
            },
            () => {
              // Do nothing
            }
          );
      public render() {
        const { deleteSchool } = this.state;
        return (
          <Page header="Manage Schools">
              <div style={{
                display: "flex",
              padding:"10px",
                width: "100%",
                marginBottom: "20px"
              }}>
                <div className="add-grit-button">
                <Button
                  style={{ marginBottom: 10 }}
                  color="primary"
                  variant="contained"
                  component={Link}
                  {...({ to: "/admin/schools/edit" } as any)}
                >
                  Add
                </Button>
                </div>
                <div className="add-grit-select">
                <select 
                  value={this.state.searchTerm}
                  onChange={this.handleInputChange} 
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "8px",
                    padding: "0 10px",
                    border: "1px solid #ccc",
                    outline: "none",
                    cursor: "pointer",
                    backgroundColor: "white",
                    marginLeft:"5px"
                                    }}
                >
                  <option value="all">All</option>
                  <option value='true'>Active</option>
                  <option value='false'>Deactive</option>
                </select>
              </div>
              </div>
            <SearchSchoolView onSubmit={(searchBy: any, searchValue: any) => {
              this.setState({
                page: 1,
                totalPage: 1,
                searchBy,
                searchValue,
                screenSchool: []
              }, () => {
                this.loadUserGetSchool()
              })

            }} />
            {this.renderSchoolList()}
            {deleteSchool === undefined ? null : this.deleteModal(deleteSchool)}
          </Page>
        );
      }

      private deleteModal(deleteSchool: ISchool) {
        const { modalVisible, deleteSchoolSlug } = this.state;
        return (
          <Modal open={modalVisible} closeModal={this.closeModal}>
            <Grid
              style={{ height: "100%" }}
              container={true}
              direction="column"
              justifyContent="space-between"
            >
              <Grid>
                <h1 className="deleteschool-name">{deleteSchool.name}</h1>
                <span>
                  Are you sure you want to delete {deleteSchool.name}?
                </span>
                <br />
                <br />
                <span>
                  Type in the school slug in order to activate delete button
                </span>
                <br />
                <br />
                <span className="slug-deleteschool">slug: {deleteSchool.slug}</span>
                <br />
                <TextField
                  value={deleteSchoolSlug}
                  onChange={this.deleteSchoolSlugChange}
                />
              </Grid>
              <Grid container={true} justifyContent="space-between" style={{paddingBottom:"10px"}}>
                <Button onClick={this.closeModal} variant="contained">
                  Back
                </Button>
                <Button
                  disabled={deleteSchool.slug !== deleteSchoolSlug}
                  // onClick={this.deleteSchool}
                  variant="contained"
                  color="secondary"
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
          </Modal>
        );
      }

      private renderSchoolList() {
        // const { loadingSchools } = this.props;
        const { screenSchool } = this.state
        return (
          <List>
            {/* {loadingSchools && <LinearProgress />} */}
            {/* <div>{screenSchool.length}</div> */}
            {screenSchool.map((school: any) => {
              if (this.state.listDeleteSchool.length > 0 && this.state.listDeleteSchool.includes(school?.id)) {
                return null
              }
              return (
                <ListItem
                  divider={true}
                  key={school.id}
                  className={this.props.classes.listItem}
                  component={Link}
                  {...({ to: `/admin/schools/edit/${school.id}` } as any)}
                >
                  <ListItemAvatar>
                    <Avatar src={school.logo1}>
                      {school.logo1 === "" ? (
                        <School style={{ fill: school.primaryColor }} />
                      ) : null}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    secondary={`${school.tagline}`}
                    primary={`${school.name}`}
                  />
                  <ListItemSecondaryAction>
                    <Tooltip title="Edit" placement="left">
                      <IconButton
                        aria-label="Edit"
                        component={Link}
                        {...({ to: `/admin/schools/edit/${school.id}` } as any)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                    {/* <Tooltip title="Delete" placement="left">
                      <IconButton
                        aria-label="Delete"
                        onClick={this.openModal(school)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip> */}
                    {console.log("schoollll daattttta", school)}
                    <Tooltip
                    title={
                      <Typography style={{ fontSize: "14px", padding: "8px", display: "block", maxWidth: "250px" }}>
                       {school.status ? "Warning: Deactivating this school will hide it from all users and restrict access until reactivated.":
                       "Info: Activating this school will make it visible to all users and restore full access."
                    }
                      </Typography>
                    }
  placement="left"
  arrow={true}
>

                  <FormControlLabel
  style={{ marginTop: "7px" }}
  control={
    <Switch
      checked={school.status === true}
      onChange={(e) => {
        const isChecked = e.target.checked;

        // If school is deactivated & user is trying to activate it
        if (!school.status && isChecked && (school?.isAdSurvey || school?.ismidseason )) {
          const confirmActivation = window.confirm(
            "You’ve enabled this add-on. Please ensure pricing is set correctly on the Membership page for this school."
          );

          if (!confirmActivation) {
            e.preventDefault();
            return;
          }
        }
        this.ToggleSchol(school.id, isChecked);
      }}
      value="check"
    />
  }
  label=""
/>
</Tooltip>
                              
                  </ListItemSecondaryAction>
                </ListItem>
              )
            })}
            {this.state.page < this.state.totalPage && <Typography
              style={{
                textAlign: 'center',
                color: "#000",
                padding: "15px 10px"
              }}
              variant="body2"
              onClick={() => {
                if (this.state.page < this.state.totalPage) {
                  this.setState({ page: this.state.page + 1 }, () => {
                    this.loadUserGetSchool()
                  })
                }
              }}
            >
              <span style={{cursor:"pointer"}}>
              Show More
              </span>
            </Typography>}

            {this.state.loadMore && <Box style={{
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 0,
            }} position="absolute">
              <CircularProgress
                size="3rem"
                style={{ color: "#494b8f", }}
              />
            </Box>}
          </List>
        );
      }

      private closeModal = () =>
        this.setState({ modalVisible: false, deleteSchoolSlug: "" });

      // private openModal = (deleteSchool: ISchool) => () =>
      //   this.setState({ modalVisible: true, deleteSchool });

      private async ToggleSchol(id: number, newStatus: boolean) {
        console.log("idd stt", id, newStatus)
        // Step 1: Update UI immediately
        const previousSchools = [...this.state.screenSchool];
        const updatedSchools = previousSchools.map((school) =>
          school.id === id ? { ...school, status: newStatus } : school
        );
      
        this.setState({ screenSchool: updatedSchools });
        
        // Step 2: Make API call
        try {
          const res: any = await this.buildPut(
            this,
            `/school/deleteStatusSchool/${id}`
          )({ status: newStatus });
      
          if (!res.status) {
            throw new Error("Status update failed");
          }
      
          // alert("Status updated successfully");
          if (newStatus === false) {
            alert("Your school has been deactivated. Please contact the administrator.");
          } else {
            alert("The school has been activated and is now visible to users.");
          }
        } catch (error) {
          // Step 3: Rollback if failed
          console.error("Error updating status:", error);
          alert("Failed to update status");
      
          // Revert the state
          this.setState({ screenSchool: previousSchools });
        }
      }
      

      // private deleteSchool = () =>
      //   void this.runCancellableStatefulAsync(
      //     this,
      //     {},
      //     {
      //       deleteSchoolSlug: "",
      //       modalVisible: false,
      //     },
      //     async () => {
      //       const { deleteSchool, deleteSchoolSlug } = this.state;
      //       if (deleteSchool !== undefined) {
      //         await this.buildDelete<void>(
      //           this,
      //           `school/${deleteSchool.id}/${deleteSchoolSlug}`
      //         )();
      //         // this.props.loadSchools();
      //         this.setState({ listDeleteSchool: [...this.state.listDeleteSchool, deleteSchool.id] })
      //         this.setState({
      //           screenSchool: []
      //         }, () => {
      //           this.loadUserGetSchool()
      //         })
      //       }
      //     },
      //     () => {
      //       const { deleteSchool } = this.state;
      //       // this.props.loadSchools();
      //       window.alert(
      //         `Failed to delete school: ${deleteSchool ? deleteSchool.name : "undefined school"
      //         }`
      //       );
      //     }
      //   );
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/admin/SchoolsPage.tsx